// React
import { memo, useMemo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { VEHICLE_PRICE_COLUMNS } from "./consts";
import { VehiclePriceMatrixCardProps } from "./types";

/**
 * Cijena po vozilu, po kombinaciji packova.
 *
 * Kombinacija je skup redaka, ne stupac — zato se matrica širi dodavanjem packa kroz sučelje,
 * bez izmjene koda.
 */
const VehiclePriceMatrixCard: React.FC<VehiclePriceMatrixCardProps> = (
  props: VehiclePriceMatrixCardProps
) => {
  const { combinations, packs } = props;

  const columns = useMemo(() => VEHICLE_PRICE_COLUMNS(packs), [packs]);

  return (
    <div className="p-6">
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px]">
          <p className="text-base font-bold text-slate-600 py-3">Cijena po vozilu</p>
          <p className="text-sm text-slate-500">
            Ovisi isključivo o kombinaciji paketa. Dodavanjem novog paketa matrica se širi ovdje,
            bez izmjene koda.
          </p>
        </div>

        <div className="flex-1">
          {combinations.length === 0 ? (
            <p className="text-sm text-slate-400 py-3">Ova verzija nema nijednu kombinaciju.</p>
          ) : (
            <TableSearch
              columns={columns}
              data={combinations}
              selectableRows={false}
              disablePagination
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(VehiclePriceMatrixCard);
